declare const WebTour: any;
// https://github.com/votch18/webtour.js#options
export class TourController{
    private ws: any;
    public steps!: TourStep[];
    public options?: TourOptions;
    constructor(){
        this.steps = [];
    }

    public onStartTour(){
        this.onInitTour();
    }

    public onLoadingTour(){
        this.ws.isPaused = true;
        this.ws.showLoader();   
    }

    /**
     * start the tour
     * @param startIndex 
     * @returns 
     */
    public onStart = (startIndex?: number) => this.ws.start(startIndex);
    /**
     * requires array of step object { element, title, content, placement } - provide one option
     * @param step 
     * @returns 
     */
    public onSetStep = (step: Array<TourStep>) => this.ws.setSteps(step);

    /**
     * requires step object { element, title, content, placement } - provide one option
     * @param step 
     * @returns 
     */
    public onRenderStep = (step: TourStep) => this.ws.render(step);
    
    public onNextStep = () => this.ws.next();

    public onPreviousStep = () => this.ws.previous();

    /**
     * resume tour and move next
     * @returns 
     */
    public onMoveNextTour = () => this.ws.moveNext();
    
    /**
     * resume tour and move previous
     * @returns 
     */
    public onMovePreviousTour = () => this.ws.movePrevious();

    public onConfigTour(steps: Array<TourStep>, options?: TourOptions){
        steps.map(s =>{
            if(!s.title) 
                s.title = 'Defontana E-commerce'
            if(!s.placement)
                s.placement = TourStepPosition.RIGHT_START
            return s;
        });
        this.steps = steps;
        this.options = options;
    }

    private onInitTour(){
        if (!this.ws) {
            this.ws = new WebTour({ ...this.options });
        }
        this.onSetStep(this.steps);
        this.onStart();
    }
}

export interface TourStep {
  element: any; //target element (if not defined then the popover will act like a modal at the center of the screen)
  content: string; //can be string or html string
  title?: string; //this is option if you don't want to add title
  placement?: TourStepPosition;
  onNext?: () => void;
  onPrevious?: () => void;
}

export enum TourStepPosition{
    TOP = 'top',
    TOP_START = 'top-start',
    TOP_END ='top-end',
    LEFT = 'left',
    LEFT_START = 'left-start',
    LEFT_END = 'left-end',
    RIGHT = 'right',
    RIGHT_START = 'right-start',
    RIGHT_END = 'right-end',
    BOTTOM = 'bottom',
    BOTTOM_START = 'bottom-start',
    BOTTM_END = 'bottom-end'
}

export interface TourOptions {
  offset?: number; //distance from popover to target element
  borderRadius?: number; //popover border radius
  allowClose?: boolean; //close on click outside
  highlight?: boolean; //show overlay
  highlightOffset?: number; //overlay offset from target element
  keyboard?: boolean; //enable/disable keyboard controll
  width?: string; //specify popover's width
  zIndex?: number; //specify z-index
  removeArrow?: boolean; //show/hide popover arrow
}